var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1304_21837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.6665 3.48828C2.6665 3.0573 2.83771 2.64398 3.14246 2.33923C3.4472 2.03449 3.86053 1.86328 4.2915 1.86328H9.70817C10.1391 1.86328 10.5525 2.03449 10.8572 2.33923C11.162 2.64398 11.3332 3.0573 11.3332 3.48828V12.1701C11.3332 12.8309 10.5857 13.2155 10.0483 12.8315L6.99984 10.654L3.95134 12.8315C3.41346 13.2161 2.6665 12.8315 2.6665 12.1707V3.48828Z",
    fill: "#6796CF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1304_21837"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(0.5 0.779297)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGroup);
export default __webpack_public_path__ + "static/media/IconGroup.925a4096190ebed4948d68c342937ea9.svg";
export { ForwardRef as ReactComponent };